import actions from './actions'

export default function EmailDeliverysReducer(state = { loading: false }, action) {
  switch (action.type) {
    case actions.REQUESTING:
      return {
        ...state,
        loading: true,
        saveSuccess: false,
      }
    case actions.LIST_EMAILDELIVERY:
      return {
        ...state,
        result: action.result,
        loading: false,
        saveSuccess: false,
      }
    case actions.EDIT_EMAILDELIVERY:
      return {
        ...state,
        editing: action.result,
        loading: false,
        saveSuccess: false,
      }
    case actions.RESET_EMAILDELIVERY:
      return {
        ...state,
        editing: null,
        loading: false,
        saveSuccess: false,
      }
    case actions.NEW_EMAILDELIVERY:
      return {
        ...state,
        editing: { emailDeliveryID: 0 },
        loading: false,
        saveSuccess: false,
      }
    case actions.CREATE_EMAILDELIVERY_RECIEVED ||
      actions.UPDATE_EMAILDELIVERY_RECIEVED ||
      actions.DELETE_EMAILDELIVERY_RECIEVED:
      return {
        ...state,
        editing: { emailDeliveryID: 0 },
        loading: false,
        saveSuccess: true, // mark
      }
    case actions.RESPONSE_ERROR:
      return {
        ...state,
        loading: false,
        error: true,
        saveSuccess: false,
        message: action.message,
      }
    default:
      return state
  }
}
